module.exports = __webpack_public_path__ + "static/img/monitor_img_append.bea8f6d2.png";